import React from 'react';

import { ErrorState } from './ErrorState';
import { reportError } from './error-reporter';

interface AppErrorBoundaryProps {
  children: React.ReactNode;
}

interface AppErrorBoundaryState {
  error?: Error;
  reportId?: string;
}

export class AppErrorBoundary extends React.Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = {};

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    const { eventId } = reportError(
      error,
      { componentStack: info.componentStack },
      { force: true }
    );
    if (eventId) this.setState({ reportId: eventId });
  }

  render(): React.ReactNode {
    if (this.state.error) {
      return (
        <ErrorState
          error={this.state.error}
          reportId={this.state.reportId}
          variant="page"
          onRetry={() => window.location.reload()}
          onBack={() => window.history.back()}
        />
      );
    }

    return this.props.children;
  }
}
